<template>
  <thead>
    <tr class="cusmtom-thead-color">
      <td rowspan="4" class="text-center p-3 custom-header-label">
        {{ labelFirstCell }}
      </td>
    </tr>
    <tr class="cusmtom-thead-color">
      <td
        v-for="(ribbonData, week) in columns"
        :key="week"
        class="text-center p-3"
        :colspan="ribbonData.length"
      >
        <strong>{{ week }}</strong>
      </td>
      <td rowspan="4" class="text-center p-3 custom-header-label">
        {{ $t('common_words.total_general') }}
      </td>
    </tr>
    <tr>
      <template v-for="ribbonData in columns">
        <template v-for="ribbon in ribbonData">
          <td class="text-center p-3" v-bind:style="getStyleCellRibbon(ribbon)">
            {{ translateDataBaseText(ribbon.color_name, ribbon.other_values) }}
          </td>
        </template>
      </template>
    </tr>
    <tr>
      <template v-for="ribbonData in columns">
        <template v-for="ribbon in ribbonData">
          <td class="text-center p-3">
            {{ ribbon.edge }} {{ $t('common_words.week_short') }}
          </td>
        </template>
      </template>
    </tr>
  </thead>
</template>
<script>
import i18n from 'src/i18n';
import MixinTranslate from 'src/util/mixinTranslate';
export default {
  computed: {
    getLabel() {
      return this.labelFirstCell
        ? this.labelFirstCell
        : i18n.t('common_words.allotment');
    },
  },
  name: 'thead-by-age-week',
  mixins: [MixinTranslate],
  props: {
    labelFirstCell: {
      type: String,
      default: null,
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'reportByAgeAndWeek',
    },
  },
  methods: {
    getStyleCellRibbon(row) {
      return (
        'background-color:' +
        row.color_code +
        ';color:' +
        row.color_text +
        '; font-weight: bold;'
      );
    },
  },
};
</script>
